import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, View } from '@adobe/react-spectrum';
import CheckmarkCircle from '@spectrum-icons/workflow/CheckmarkCircle';
import { EditorActions } from 'app/stores/editor/actions';
import { useAppDispatch } from 'app/stores/store';
import { Text } from 'app/views/components/typography/Text';
import { noop } from 'app/utils/function';
export const Toast = () => {
    const dispatch = useAppDispatch();
    const toast = useSelector((state) => { var _a; return (_a = state.editor.toasts) === null || _a === void 0 ? void 0 : _a[0]; });
    React.useEffect(() => {
        if (!toast) {
            return noop;
        }
        const displayTime = Math.round(Math.min(8000, Math.max(3000, toast.message.length * 50)));
        const timerId = setTimeout(() => {
            dispatch(EditorActions.popToast());
        }, displayTime);
        return () => {
            if (timerId) {
                clearTimeout(timerId);
            }
        };
    }, [toast, dispatch]);
    if (!toast) {
        return null;
    }
    return (React.createElement(View, { position: "fixed", left: "50%", top: "size-50", zIndex: 10000, backgroundColor: toast.variant, paddingY: "size-85", paddingX: "size-200", borderRadius: "small", UNSAFE_style: { transform: 'translate(-50%, 0px)' } },
        React.createElement(Flex, { gap: "size-125", alignItems: "center" },
            React.createElement(CheckmarkCircle, { size: "XS" }),
            React.createElement(Text, { size: "S", color: "static-white" }, toast.message))));
};
